import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { ApolloError } from '@apollo/client';
import RoutePath from 'App/RoutePath';

import {
  getServices_bookableServices,
  useGetServices,
} from 'Book/pages/Book/hooks/useGetServices';

interface UseBookAccessResult {
  loading: boolean;
  error: ApolloError | undefined;
  bookableService: getServices_bookableServices | null | undefined;
  serviceSlug: string;
}

export const useBookServiceAccess = (): UseBookAccessResult => {
  const { data, loading, error } = useGetServices();
  const history = useHistory();
  const { service: serviceSlug } = useParams<{
    service: string;
  }>();

  const [details, setDetails] = useState<
    undefined | null | getServices_bookableServices
  >(undefined);

  useEffect(() => {
    if (data?.bookableServices?.length) {
      const serviceDetails = data?.bookableServices?.find(
        s => s.serviceSlug === serviceSlug,
      );

      if (serviceDetails) {
        setDetails(serviceDetails);
      } else {
        setDetails(null);
        history.replace(RoutePath.Book);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.bookableServices, serviceSlug]);

  return { loading, error, bookableService: details, serviceSlug };
};
